export function isDomReady() {
  return new Promise((resolve, reject) => {
    // check dom ready
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      resolve();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        resolve();
      }, false);
    }
  });
}

export const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const isDesktopMedia = window.matchMedia('(min-width: 992px)');